import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { CharacteristicSearchModel } from '../../common/viewModels/GlobalRegistry/CharacteristicsModel';
import { UnitsModel } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { PagerService } from '../../common/pagerService';
import { PageResultDto } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { ToastrService } from 'ngx-toastr';
declare var $: any;

@Component({
    selector: 'characteristics',
    templateUrl: './characteristics.component.html',
    styleUrls: ['./characteristics.component.scss']
})
export class CharacteristicsComponent implements OnInit {
    characteristicsForm: FormGroup;
    characteristicsSearchForm: FormGroup;
    searchFields: CharacteristicSearchModel = new CharacteristicSearchModel();
    unitsList: UnitsModel[];
    isNoRecords: boolean = true;
    pager: any = {};
    pagedItems: any[];
    pageResult: PageResultDto;
    id: number;
    length: number = 0;
    mainComponent: any;
    isSubmitted: false;
    lstTestMethods: any;
    lstCharacteristics: any;
    pageSize: number = 10;
    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _mApp: MainAppComponent, private _pageSrvc: PagerService,
        private _toastrService: ToastrService,

    ) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
        this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageSize = this.pageSize;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
        this.searchFields = new CharacteristicSearchModel();
        this.CreateForm();
        this.characteristicsSearchForm = this._formBuilder.group({
            Name: ['']
        });
        this.setPage(this.pager);
        this.GetUnitsList();
        this.GetListOfMinTestMethods();
        this.GetCharacteristicsMinInfoList();

    }

    CreateForm() {
        this._formBuilder = new FormBuilder();
        this.characteristicsForm = this._formBuilder.group({
            CharacteristicId: [0],
            Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
            UnitId: [''],
            TestMethodId: [''],
            Description: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(500)])],
            ShowInOilGrades: [''],
            ShowInGeneralSamples: [''],
            ShowInFerrographySamples: [''],
            ShowInTataSamples: [''],
            ShowInTransformerSamples:[''],
            IsLabelOnly: [''],
            ParentCharId: [''],
            AliasName: [''],
            
        });
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        // this.pageSizeOptions.pop(page.pageSize);
        this.GetCharectisticsList(this.pager);
    }

    GetCharectisticsList(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        // this.searchFields.PageIndex=page.pageIndex;
        let subscription = this._http.post(this._appUrl.GetCharectisticsList, this.searchFields)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var response = data.json();
                    this.length = response.PageResult.TotalRecords;
                    this.pagedItems = response.Result;
                    this.isNoRecords = !(response.Result.length > 0);
                },
                error => {
                    this._mApp.HideLoader();
                    this.pagedItems = null;
                    this.isNoRecords = true;
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    GetUnitsList() {
        this._http.get(this._appUrl.GetUnitsForDDL)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.unitsList = data.json().Result
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetListOfMinTestMethods() {
        this._http.get(this._appUrl.GetListOfMinTestMethods)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstTestMethods = data.json().Result
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }
    GetCharacteristicsMinInfoList() {
        this._http.get(this._appUrl.GetCharacteristics + "?isLabelOnly=" + true)
            .subscribe(
                data => {
                    if (data.json().Result != null)
                        this.lstCharacteristics = data.json().Result
                },
                error => {
                    //this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetCharacteristicsById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetCharacteristicsById + id)
            .subscribe(
                m => {

                    this._mApp.HideLoader();
                    if (m.json().Result != null) {
                        this.characteristicsForm.setValue(m.json().Result);
                        this.GetUnitsList();
                        for (let item of this.unitsList) {
                            if (item.UnitId == m.json().Result.UnitId) {
                                this.characteristicsForm.controls['UnitId'].setValue(m.json().Result.UnitId);
                                break;
                            }
                            else
                                this.characteristicsForm.controls['UnitId'].setValue(null);
                        }
                    }
                }, error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    DeleteCharacteristic(id: any) {
        this.id = id;
    }

    DeleteCharacteristicById(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteCharesterstic + id)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result, '')
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    FetchUpdatedData() {
        this.GetUnitsList();
    }

    OnSubmit() {

        if (this.characteristicsForm.valid) {
            this._mApp.ShowLoader();
            let addCharacteristics = this.characteristicsForm.value;
            if (addCharacteristics.CharacteristicId == null || addCharacteristics.CharacteristicId === 0) {
                addCharacteristics.CharacteristicId = 0;
            }
            this._http.post(this._appUrl.AddCharectistics, addCharacteristics)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result, '');
                        $('#addCharacteristicModel').modal('toggle');
                        this.Clear();
                        this.setPage(this.pager);
                        this.GetCharacteristicsMinInfoList();
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result, '')
                    }
                )
        }
    }

    OnSearchSubmit() {
        this.pager.pageIndex = 0;
        if (this.characteristicsSearchForm.valid) {
            this.searchFields = this.characteristicsSearchForm.value;

        }
        this.ConstructSearchData();
        this.setPage(this.pager);
    }

    ConstructSearchData() {
        let searchDto = this.characteristicsSearchForm.value;
        this.searchFields.Name = searchDto.Name;
    }

    Clear() {
        this.characteristicsForm.reset();
    }

    OnReset() {
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.characteristicsSearchForm.reset();
        this.searchFields.Name = '';
        this.GetUnitsList();
        this.GetCharacteristicsMinInfoList();
        this.setPage(this.pager);
    }

}
